export enum RequestStatus {
  PENDING = 1,
  FINISH,
  FAILED,
}
